import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "py-3" }
const _hoisted_2 = {
  key: 0,
  class: "background-orange-lighten-5 px-4 mb-4 py-3 flex items-center justify-between"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("p", { class: "font-bold color-primary lg:text-base md:text-sm text-sm" }, "Refresh Dashboard Untuk Mendapatkan Data Terbaru!", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "aria-hidden": "true",
  focusable: "false",
  class: "h-5 w-5 mr-2",
  style: {"-ms-transform":"rotate(360deg)","-webkit-transform":"rotate(360deg)","transform":"rotate(360deg)"},
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 512 512"
}, [
  /*#__PURE__*/_createVNode("path", {
    d: "M256 48C141.31 48 48 141.32 48 256c0 114.86 93.14 208 208 208c114.69 0 208-93.31 208-208c0-114.87-93.13-208-208-208zm94 219a94 94 0 1 1-94-94h4.21l-24-24L256 129.2l59.8 59.8l-59.8 59.8l-19.8-19.8l27.92-27.92c-2.4-.08-5.12-.08-8.12-.08a66 66 0 1 0 66 66v-14h28z",
    fill: "white"
  })
], -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "text-white font-bold lg:text-base md:text-sm text-sm" }, "Refresh", -1)
const _hoisted_6 = { class: "grid lg:grid-cols-2 md:grid-cols-1 gap-4" }
const _hoisted_7 = {
  key: 3,
  class: "bg-white p-4 shadow rounded-lg mb-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_ListAccumulate = _resolveComponent("ListAccumulate")
  const _component_ManifestInfo = _resolveComponent("ManifestInfo")
  const _component_PickupInfo = _resolveComponent("PickupInfo")
  const _component_LabelStickerAvailable = _resolveComponent("LabelStickerAvailable")
  const _component_SearchReceipt = _resolveComponent("SearchReceipt")
  const _component_TabPanel = _resolveComponent("TabPanel")
  const _component_TabView = _resolveComponent("TabView")
  const _component_ReceiveItemTable = _resolveComponent("ReceiveItemTable")
  const _component_DeliveryItemTable = _resolveComponent("DeliveryItemTable")
  const _component_PendingTable = _resolveComponent("PendingTable")
  const _component_RefundTable = _resolveComponent("RefundTable")
  const _component_DialogHandoverItem = _resolveComponent("DialogHandoverItem")
  const _component_DialogDetailResi = _resolveComponent("DialogDetailResi")
  const _component_DialogAddPendingManifest = _resolveComponent("DialogAddPendingManifest")
  const _directive_scroll = _resolveDirective("scroll")

  return _withDirectives((_openBlock(), _createBlock("section", _hoisted_1, [
    (_ctx.checkPermission(_ctx.Permision.ViewDashboard))
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_Button, {
            class: "p-button p-button-sm rounded-lg flex items-center py-1 px-2 btn-primary",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.refreshDashboard()))
          }, {
            default: _withCtx(() => [
              _hoisted_4,
              _hoisted_5
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx.checkPermission(_ctx.Permision.ViewDashboard))
      ? (_openBlock(), _createBlock(_component_ListAccumulate, { key: 1 }))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_6, [
      (_ctx.checkPermission(_ctx.Permision.ViewDashboard))
        ? (_openBlock(), _createBlock(_component_ManifestInfo, { key: 0 }))
        : _createCommentVNode("", true),
      (_ctx.checkPermission(_ctx.Permision.ViewDashboard))
        ? (_openBlock(), _createBlock(_component_PickupInfo, { key: 1 }))
        : _createCommentVNode("", true)
    ]),
    (_ctx.checkPermission(_ctx.Permision.ViewDashboard))
      ? (_openBlock(), _createBlock(_component_LabelStickerAvailable, {
          key: 2,
          class: "my-4"
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_SearchReceipt, { class: "mb-4 " }),
    (_ctx.checkPermission(_ctx.Permision.ViewDashboard) && _ctx.isGetDashboard)
      ? (_openBlock(), _createBlock("div", _hoisted_7, [
          _createVNode(_component_TabView, {
            class: "color-primary mb-4",
            activeIndex: _ctx.indexTab,
            "onUpdate:activeIndex": _cache[2] || (_cache[2] = ($event: any) => (_ctx.indexTab = $event))
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tabsHeader, (item) => {
                return (_openBlock(), _createBlock(_component_TabPanel, {
                  key: item.value,
                  header: item.title
                }, null, 8, ["header"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["activeIndex"]),
          (_ctx.indexTab == 1)
            ? (_openBlock(), _createBlock(_component_ReceiveItemTable, {
                key: 0,
                id: 'receiveItem',
                ref: "receiveItem",
                onShowDetail: _ctx.showDetail,
                onSubmitDropAgent: _ctx.submitDropAgent,
                onSubmitHandoverItem: _ctx.submitHandoverItem
              }, null, 8, ["onShowDetail", "onSubmitDropAgent", "onSubmitHandoverItem"]))
            : (_ctx.indexTab == 0)
              ? (_openBlock(), _createBlock(_component_DeliveryItemTable, {
                  key: 1,
                  id: 'deliveryItem',
                  ref: "deliveryItem",
                  onShowPending: _ctx.showPending,
                  onShowRefund: _ctx.showRefund,
                  onShowDetail: _ctx.showDetail,
                  onSubmitDropAgent: _ctx.submitDropAgent,
                  onSubmitHandoverItem: _ctx.submitHandoverItem
                }, null, 8, ["onShowPending", "onShowRefund", "onShowDetail", "onSubmitDropAgent", "onSubmitHandoverItem"]))
              : (_ctx.indexTab == 2)
                ? (_openBlock(), _createBlock(_component_PendingTable, {
                    key: 2,
                    ref: "pending",
                    onShowDetail: _ctx.showDetail
                  }, null, 8, ["onShowDetail"]))
                : (_ctx.indexTab == 3)
                  ? (_openBlock(), _createBlock(_component_RefundTable, {
                      key: 3,
                      ref: "refund",
                      onShowDetail: _ctx.showDetail
                    }, null, 8, ["onShowDetail"]))
                  : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.dialogHandoverItem)
      ? (_openBlock(), _createBlock(_component_DialogHandoverItem, {
          key: 4,
          id: _ctx.selectReceipt,
          isShowDialog: _ctx.dialogHandoverItem,
          onHideDialog: _ctx.hideDialogHandoverItem,
          onReloadData: _ctx.toEmitReloadData
        }, null, 8, ["id", "isShowDialog", "onHideDialog", "onReloadData"]))
      : _createCommentVNode("", true),
    (_ctx.dialogDetail)
      ? (_openBlock(), _createBlock(_component_DialogDetailResi, {
          key: 5,
          isRefund: _ctx.supportRefund,
          idTrans: _ctx.selectReceipt,
          isShowDialog: _ctx.dialogDetail,
          onHideDialog: _ctx.hideDialogDetail,
          onReloadData: _ctx.toEmitReloadData
        }, null, 8, ["isRefund", "idTrans", "isShowDialog", "onHideDialog", "onReloadData"]))
      : _createCommentVNode("", true),
    (_ctx.dialogPending)
      ? (_openBlock(), _createBlock(_component_DialogAddPendingManifest, {
          key: 6,
          deliveryHdId: _ctx.selectReceipt,
          isShowDialog: _ctx.dialogPending,
          onHideDialog: _ctx.hidePending,
          onReloadData: _ctx.toEmitReloadData
        }, null, 8, ["deliveryHdId", "isShowDialog", "onHideDialog", "onReloadData"]))
      : _createCommentVNode("", true)
  ], 512)), [
    [_directive_scroll, _ctx.scrollFunction]
  ])
}